import { useMemo } from 'react';

import { useGetLocationGroupsByUuids } from '@occc-app/dataAccessLayer/locationGroup/queries';
import { ChipList } from '@occc-app/routes/CampaignComponents/component-details/components';
import { routeCreator as locationRouteCreator } from '@occc-app/routes/Location/utils';

type GroupChipsProps = {
  groupIds: string[];
  label: string;
  emptyPlaceholder?: string;
};

export const GroupChips = ({ groupIds, label, emptyPlaceholder }: GroupChipsProps) => {
  const { data, loading } = useGetLocationGroupsByUuids(groupIds);

  const chips = useMemo(() => {
    return (data ?? []).map((group) => ({
      label: group.name,
      href: locationRouteCreator.locationGroupDetails(group.uuid),
    }));
  }, [data]);

  return (
    <ChipList isLoading={loading} label={label} items={chips} emptyPlaceholder={emptyPlaceholder} />
  );
};
